import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { HttpHeadersService } from '../../core/shared-service/http-headers.service';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GetSoftwarePendingCountService {

  lastFacilityId: string;
  response: IPendingCountResponse;
  isLoading: boolean = false;
  getSoftwarePendingCountPromise: Promise<IPendingCountResponse>;

  constructor(private httpClient: HttpClient, private rootScopeService: RootScopeService,
    private httpHeaderService: HttpHeadersService) {
  }

  public getSoftwarePendingCount(facilityId: string): Promise<IPendingCountResponse> {

    if (this.isLoading) {
      return this.getSoftwarePendingCountPromise;
    } else {
      
      if (this.lastFacilityId == facilityId) {
        return new Promise((resolve, reject) => { resolve(this.response); });
      } else {
        this.getSoftwarePendingCountPromise = new Promise((resolve, reject) => {
          this.isLoading = true;
          const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
          const postData: any = {};
          postData.facilityIds = facilityId;
          this.lastFacilityId = facilityId;
          this.httpClient.post(`${environment.servicePath}/software_update/get_pending_count`, postData, { headers })
            .subscribe((res: IPendingCountResponse) => {
              this.response = res;
              this.isLoading = false;
              resolve(res);
            }, err => {
              this.isLoading = false;
              reject();
            });
        });

        return this.getSoftwarePendingCountPromise;
      }

    }

  }
}


export interface IPendingCountResponse {
  consoleAssetSoftware: IConsoleAssetSoftware[];
  totalPendingCount: string;
}

export interface IConsoleAssetSoftware {
  console: string;
  pendingCount: string;
}
